import React, { useEffect, useRef, useState } from 'react';
import useEVStyles from './useEVStyles';
import { useDebounce } from '../../hooks/useDebounce';
import { getActiveInitRoute, getPermissions } from '../../utils/permissions';
import { useDispatch, useSelector, DefaultRootState } from 'react-redux';
import { Spinner } from '../../components/UI';
import EmptyState from '../../components/EmptyState';
import {
    GetCities,
    blockUnblockEV,
    energyControlEV,
    evBlockAPI,
    evBlockIotAPI,
    evBlockEnergyAPI,
    deleteEvVehicle,
    getAllEVCaptainsStaffpay,
    getAllEVProjects,
    getAllEVTeams,
    getAllEVVehicles,
    getAllEVVehiclesV2,
    getAllEVVendors,
    getAllEVTelematics,
} from '../../store/actions/settingsActionCreator';
import {
    Box,
    Button,
    Divider,
    Grid,
    Paper,
    Popover,
    Table,
    TableBody,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    Typography,
} from '@material-ui/core';
import FilterModal, {
    FILTER_INPUT_TYPE,
    FilteredState,
} from '../../components/Modals/FilterModal';
import Searchbar from '../../components/Searchbar';
import {
    EVVEHICLE_STATUS_LIST,
    EVVEHICLE_STATUS_LIST_V2,
} from '../settings/EVVehicles';
import {
    EV_FILTER_CARDS,
    EV_SEVERITY_TABS,
    generateMockData,
    getEffectiveDecayDays,
    getEvBucket,
    preProcessPayload,
    removeKeysFromObject,
    tableConfig,
} from './helper';
import useEVTable from './useEVTable';
import io, { Socket } from 'socket.io-client';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import { groupBy, showMessage, formatEvBlockResult } from '../../utils/helper';
import usePrevious from '../../hooks/usePrevious';
import ConfirmModal from '../../components/Modals/ConfirmModal';
import SendLocationModal from './components/SendLocationModal';
import BlockUnblockModal from './components/BlockUnblockModal';

const SearchableSelect: React.FC<any> = ({
    label,
    value,
    options,
    onChange,
}: {
    label: string;
    value: string;
    options: Array<{ label: string; value: string }>;
    onChange: (v: string) => void;
}) => {
    const [anchor, setAnchor] = useState<any>(null);
    const [query, setQuery] = useState('');
    const selected = options.find((o) => o.value === value);
    const display = selected ? selected.label : `${label}: All`;
    const filtered = options.filter((o) =>
        o.label?.toLowerCase().includes(query.trim().toLowerCase()),
    );
    return (
        <>
            <Box
                onClick={(e: any) => setAnchor(e.currentTarget)}
                style={{
                    height: 40,
                    border: '1px solid #EBEDF8',
                    borderRadius: 10,
                    background: '#FFFFFF',
                    padding: '0 12px',
                    fontSize: 13,
                    color: '#14112D',
                    fontWeight: 600,
                    cursor: 'pointer',
                    minWidth: 140,
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 8,
                    justifyContent: 'space-between',
                }}
            >
                <span
                    style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        maxWidth: 180,
                    }}
                >
                    {display}
                </span>
                <span style={{ color: '#9AA3B2', fontSize: 11 }}>▾</span>
            </Box>
            <Popover
                open={!!anchor}
                anchorEl={anchor}
                onClose={() => {
                    setAnchor(null);
                    setQuery('');
                }}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                PaperProps={{
                    style: {
                        marginTop: 6,
                        borderRadius: 10,
                        border: '1px solid #EBEDF8',
                        boxShadow: '0 8px 24px rgba(20,17,45,0.08)',
                        width: 260,
                    },
                }}
            >
                <Box style={{ padding: 8 }}>
                    <Box
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            border: '1px solid #EBEDF8',
                            borderRadius: 8,
                            padding: '6px 10px',
                            marginBottom: 6,
                        }}
                    >
                        <span style={{ color: '#9AA3B2', marginRight: 6, fontSize: 12 }}>
                            🔍
                        </span>
                        <input
                            autoFocus
                            value={query}
                            onChange={(e: any) => setQuery(e.target.value)}
                            placeholder={`Search ${label}`}
                            style={{
                                border: 'none',
                                outline: 'none',
                                flex: 1,
                                fontSize: 13,
                                background: 'transparent',
                                color: '#14112D',
                            }}
                        />
                    </Box>
                    <Box style={{ maxHeight: 240, overflowY: 'auto' }}>
                        <Box
                            onClick={() => {
                                onChange('');
                                setAnchor(null);
                                setQuery('');
                            }}
                            style={{
                                padding: '8px 10px',
                                fontSize: 13,
                                cursor: 'pointer',
                                borderRadius: 6,
                                color: !value ? '#14112D' : '#515f6d',
                                fontWeight: !value ? 700 : 500,
                                background: !value ? '#F3F6FF' : 'transparent',
                            }}
                        >
                            All
                        </Box>
                        {filtered.length === 0 ? (
                            <Box
                                style={{
                                    padding: '8px 10px',
                                    fontSize: 12,
                                    color: '#9AA3B2',
                                }}
                            >
                                No matches
                            </Box>
                        ) : (
                            filtered.map((o) => {
                                const active = o.value === value;
                                return (
                                    <Box
                                        key={o.value}
                                        onClick={() => {
                                            onChange(o.value);
                                            setAnchor(null);
                                            setQuery('');
                                        }}
                                        style={{
                                            padding: '8px 10px',
                                            fontSize: 13,
                                            cursor: 'pointer',
                                            borderRadius: 6,
                                            color: active ? '#14112D' : '#515f6d',
                                            fontWeight: active ? 700 : 500,
                                            background: active ? '#F3F6FF' : 'transparent',
                                        }}
                                    >
                                        {o.label}
                                    </Box>
                                );
                            })
                        )}
                    </Box>
                </Box>
            </Popover>
        </>
    );
};

const EVPage: React.FC = ({
    heliosTrackingData = [],
    staffTrackAndTrace,
    ...props
}: any) => {
    const { debounce, isBouncing } = useDebounce();
    const isPageReload = (() => {
        try {
            const entries = (performance as any)?.getEntriesByType?.('navigation');
            if (entries?.[0]?.type === 'reload') return true;
            if ((performance as any)?.navigation?.type === 1) return true;
        } catch {}
        return false;
    })();
    const previousSelection = isPageReload
        ? null
        : props?.location?.state?.selectedFilter ?? null;
    const isCmMode = (props?.location?.pathname || props?.match?.path || '').includes('/ev-cm');
    const SOCKET_SERVER_URL = 'https://www.beecon.in/webSocket'; // Replace with your server URL
    const dispatch = useDispatch();
    const dispatchGetEvVehiclesListData = (
            payload: any,
            onSuccess?: Function,
            onError?: Function,
        ) => dispatch(getAllEVVehiclesV2(payload, onSuccess, onError)),
        dispatchDeleteEV = (
            id: any,
            onSuccess?: Function,
            onError?: Function,
        ) => dispatch(deleteEvVehicle(id, onSuccess, onError)),
        dispatchBlockUnblockEV = (
            payload: any,
            onSuccess?: Function,
            onError?: Function,
        ) => dispatch(blockUnblockEV(payload, onSuccess, onError)),
        dispatchEnergyControlEV = (
            payload: any,
            onSuccess?: Function,
            onError?: Function,
        ) => dispatch(energyControlEV(payload, onSuccess, onError)),
        dispatchEvBlock = (
            payload: any,
            onSuccess?: Function,
            onError?: Function,
        ) => dispatch(evBlockAPI(payload, onSuccess, onError)),
        dispatchEvBlockIot = (
            payload: any,
            onSuccess?: Function,
            onError?: Function,
        ) => dispatch(evBlockIotAPI(payload, onSuccess, onError)),
        dispatchEvBlockEnergy = (
            payload: any,
            onSuccess?: Function,
            onError?: Function,
        ) => dispatch(evBlockEnergyAPI(payload, onSuccess, onError)),
        dispatchGetAllEVVendors = (
            payload: any,
            onSuccess?: Function,
            onError?: Function,
        ) => dispatch(getAllEVVendors(payload, onSuccess, onError)),
        dispatchGetAllEVTeams = (
            payload: any,
            onSuccess?: Function,
            onError?: Function,
        ) => dispatch(getAllEVTeams(payload, onSuccess, onError)),
        dispatchGetAllEVProjects = (
            payload: any,
            onSuccess?: Function,
            onError?: Function,
        ) => dispatch(getAllEVProjects(payload, onSuccess, onError)),
        dispatchGetAllEVCaptains = (
            payload: any,
            onSuccess?: Function,
            onError?: Function,
        ) => dispatch(getAllEVCaptainsStaffpay(payload, onSuccess, onError)),
        dispatchGetAllEVTelematics = (
            payload: any,
            onSuccess?: Function,
            onError?: Function,
        ) => dispatch(getAllEVTelematics(payload, onSuccess, onError)),
        dispatchGetCities = (
            payload: any,
            onSuccess?: Function,
            onError?: Function,
        ) => dispatch(GetCities(payload, onSuccess, onError));
    //store values
    const { user, mapview, staff, settings } = useSelector(
        (store: DefaultRootState | any) => store || {},
    );

    const evListData = settings?.evListV2 ?? {
        evLineItemList: [],
        totalCount: 0,
    };
    const vendorList = settings?.evVendorList ?? [],
        teamList = settings?.evTeamList ?? [],
        projectsList = settings?.evProjectList ?? [],
        captainList = settings?.evCaptainList ?? [],
        telematicsList = settings?.telematicsList ?? [],
        cmGroupMap: Record<string, { id: any; name: string; contactNumber: string | null; values: any[] }> = (captainList ?? []).reduce(
            (acc: any, c: any) => {
                const cmId = c?.cmId;
                if (cmId === null || cmId === undefined) return acc;
                const key = String(cmId);
                if (!acc[key]) {
                    acc[key] = {
                        id: cmId,
                        name: c?.cmName || `CM ${cmId}`,
                        contactNumber: c?.cmContact ?? null,
                        values: [],
                    };
                }
                acc[key].values.push(c);
                return acc;
            },
            {},
        ),
        managerList = Object.values(cmGroupMap),
        cityList = settings?.cities ?? [];
    const classes = useEVStyles();
    const [loading, setLoading] = useState(false);
    const [routeState, setRouteState] = useState<any>(null);
    const [firstRenderDone, setFirstRenderDone] = useState(false);
    const [confirmModalOpen, setConfirmModalOpen] = useState(false);
    const [confirmData, setConfirmData] = useState<any>(null);
    const [sendLocationRow, setSendLocationRow] = useState<any>(null);
    const [blockModal, setBlockModal] = useState<{
        row: any;
        mode: 'block' | 'unblock';
        partner?: 'iot' | 'energy';
    } | null>(null);
    const [blockLoading, setBlockLoading] = useState(false);
    const permKey = (props?.location?.pathname || '').includes('/ev-cm') ? 'EV CM' : 'EV SP';
    const [permissions, setPermissions] = useState(getPermissions(permKey));
    const [activeFilterCard, setActiveFilterCard] = useState(
        !!previousSelection?.activeFilterCard
            ? previousSelection?.activeFilterCard
            : 'TAGGED_FILTER',
    );
    const socketRef = useRef<any>(null);
    const [pagination, setPagination] = useState<any>({
        pageSize: 25,
        pageNo: 0,
        ...(!!previousSelection?.pagination
            ? previousSelection?.pagination
            : {}),
    });
    const [filteredValues, setFilteredValue] = useState<any>({
        evDate: {
            startDate: moment()?.subtract(30, 'days'),
            endDate: moment(),
        },
        startDate: moment()?.subtract(30, 'days')?.format('YYYY-MM-DD'),
        endDate: moment()?.format('YYYY-MM-DD'),
        evStatus: 'TAGGED',
        ...(!!previousSelection?.filteredValues
            ? previousSelection?.filteredValues
            : {}),
    });
    const prevFilterValues = usePrevious(filteredValues);
    const [searchText, setSearchText] = useState<string>(
        previousSelection?.searchText ??
            previousSelection?.evListingPayload?.searchText ??
            '',
    );
    const [activeSeverityTab, setActiveSeverityTab] = useState<string>('ALL');
    // Pan-India baseline for the 3 summary cards — captured once from the first
    // (unfiltered) API response and never overwritten, so the cards stay constant
    // even after the user applies city/vertical/CM/TL filters.
    const [baselineCardTotals, setBaselineCardTotals] = useState<{
        totalCount: number;
        criticalCount: number;
        blockedCount: number;
        partiallyBlockedCount: number;
    } | null>(null);
    const isMountedRef = useRef(true);
    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        };
    }, []);
    React.useEffect(() => {
        if (!firstRenderDone) return;
        setEvListingPayload((prev: any) => ({
            ...prev,
            pageNo: 1,
            bucket: activeSeverityTab === 'ALL' ? null : activeSeverityTab,
        }));
        setPagination((prev: any) => ({ ...prev, pageNo: 0 }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeSeverityTab]);
    // Sort is applied server-side across the FULL filtered set; null = default bucket-priority order.
    const SORT_KEY_TO_API: Record<string, string> = {
        riderMobile: 'riderName',
        wallet: 'wallet',
        decay: 'decay',
    };
    const [sortConfig, setSortConfig] = useState<{
        key: string | null;
        direction: 'asc' | 'desc';
    }>({ key: null, direction: 'asc' });
    const handleSortClick = (columnKey: string) => {
        if (!SORT_KEY_TO_API[columnKey]) return;
        setSortConfig((prev) => {
            if (prev.key !== columnKey) return { key: columnKey, direction: 'asc' };
            if (prev.direction === 'asc') return { key: columnKey, direction: 'desc' };
            return { key: null, direction: 'asc' };
        });
    };
    const SORTABLE_COLUMN_KEYS = new Set(Object.keys(SORT_KEY_TO_API));
    const [evListingPayload, setEvListingPayload] = React.useState({
        pageNo: props?.location?.state?.page ?? 1,
        pageSize: props?.location?.state?.rowsPerPage ?? 25,
        searchText: '',
        cityIds: [],
        captainsIds: [],
        cmIds: [],
        projectIds: [],
        vendorIds: [],
        telematicIds: [],
        filter: 'TAGGED_FILTER',
        evDate: {
            startDate: moment()?.subtract(30, 'days')?.format('YYYY-MM-DD'),
            endDate: moment()?.format('YYYY-MM-DD'),
        },
        startDate: moment()?.subtract(30, 'days')?.format('YYYY-MM-DD'),
        endDate: moment()?.format('YYYY-MM-DD'),
        evStatus: 'TAGGED',
        ...filteredValues,
        ...(!!previousSelection?.evListingPayload
            ? previousSelection?.evListingPayload
            : {}),
    });
    const onPressMobilize = async (row: any) => {
        if (!!row?.evId && !!row?.iotPartnerRemoteControlEnabled) {
            setLoading(true);
            dispatchBlockUnblockEV(
                {
                    evId: row?.evId,
                    action: !!row?.evTelematicInfo?.mobiliStatus
                        ? 'mobilize'
                        : 'immobilize',
                },
                (resp: any) => {
                    setLoading(false);
                    showMessage(
                        resp?.status?.message,
                        resp?.status?.code == 200 ? 'success' : 'error',
                    );
                    fetchEvVehiclesListData(preProcessPayload(evListingPayload));
                },
                () => {
                    setLoading(false);
                },
            );
        }
    };
    const onPressEnergyControl = async (row: any) => {
        if (!!row?.evId && !!row?.energyPartnerRemoteControlEnabled) {
            setLoading(true);
            dispatchEnergyControlEV(
                {
                    evId: row?.evId,
                    action: !!row?.evTelematicInfo?.energyPartnerIgnitionStatus
                        ? 'Immobilize'
                        : 'Mobilize',
                },
                (resp: any) => {
                    setLoading(false);
                    showMessage(
                        resp?.status?.message,
                        resp?.status?.code == 200 ? 'success' : 'error',
                    );
                    fetchEvVehiclesListData(preProcessPayload(evListingPayload));
                },
                () => {
                    setLoading(false);
                },
            );
        }
    };
    useEffect(() => {
        // CM mode: force cmId to logged-in user so listing/dropdowns are scoped to their TLs+riders.
        if (!isCmMode) return;
        const meId = user?.id ?? user?.userId ?? null;
        if (!meId) return;
        const meIdNum = Number(meId);
        if (filteredValues?.cmId === meIdNum) return;
        setFilteredValue((prev: any) => ({
            ...prev,
            cmId: meIdNum,
            cmIds: [meIdNum],
        }));
        setEvListingPayload((prev: any) => ({
            ...prev,
            cmIds: [meIdNum],
        }));
    }, [isCmMode, user?.id, user?.userId]);

    useEffect(() => {
        if (!isPageReload || !props?.history?.replace) return;
        const state = props?.location?.state ?? {};
        if (!('selectedFilter' in state)) return;
        const { selectedFilter, ...rest } = state;
        props.history.replace({
            pathname: props?.location?.pathname,
            state: rest,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        // Capture selectedFilter from the initial route state only — do not re-fire
        // when location.state ref changes (e.g. after history.replace above).
        if (isPageReload) return;
        const sel = props?.location?.state?.selectedFilter;
        if (!sel) return;
        setRouteState((prev: any) => prev ?? sel);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const {
        getCardFilterView,
        StyledTableHeadCell,
        StyledTableCell,
        StyledTableRow,
        getColumnComponentValue,
        handleRowClick,
        handleConfirmYes,
        handleConfirmNo,
    } = useEVTable({
        filtered: filteredValues,
        history: props?.history,
        evListData: evListData,
        baselineCardTotals,
        activeFilterCard,
        setActiveFilterCard,
        onPressMobilize,
        onPressEnergyControl,
        confirmModalOpen,
        setConfirmModalOpen,
        confirmData,
        setConfirmData,
        evListingPayload,
        pagination,
        onSendLocation: (row: any) => {
            setSendLocationRow(row);
        },
        onBlockUnblock: (
            row: any,
            mode: 'block' | 'unblock',
            partner?: 'iot' | 'energy',
        ) => {
            setBlockModal({ row, mode, partner });
        },
    });
    const fetchEvVehiclesListData = async (
        payload: any = {
            pageNo: 1,
            pageSize: 10,
            searchText: '',
            cityIds: [],
            captainsIds: [],
            cmIds: [],
            projectIds: [],
            vendorIds: [],
            telematicIds: [],
        },
    ) => {
        const meIdNum = isCmMode
            ? Number(user?.id ?? user?.userId ?? 0) || null
            : null;
        const scopedPayload = isCmMode && meIdNum
            ? { ...payload, cmIds: [meIdNum] }
            : payload;
        await setLoading(true);
        dispatchGetEvVehiclesListData(
            scopedPayload,
            (resp: any) => {
                console.log(resp);
                if (!isMountedRef.current) return;
                setLoading(false);
                const r = resp?.response ?? resp ?? {};
                const bucketCounts = r?.bucketCounts ?? {};
                setBaselineCardTotals({
                    totalCount: Number(r?.totalEv ?? r?.totalCount ?? 0),
                    criticalCount: Number(bucketCounts?.Critical ?? 0),
                    blockedCount: Number(r?.blockedEv ?? r?.blockedCount ?? 0),
                    partiallyBlockedCount: Number(
                        r?.partiallyBlockedEv ?? r?.partiallyBlockedCount ?? 0,
                    ),
                });
            },
            (err: any) => {
                console.log(err);
                setLoading(false);
            },
        );
    };

    const startLiveDataUpdate = () => {
        const options = {
            forceNew: true,
            autoConnect: true,
            pingInterval: 6000,
            pingTimeout: 10000,
            // transports: ['websocket'],
            agent: false, // [2] Please don't set this to true
            query:
                'token=' +
                user?.config?.beeconWebSocketToken +
                // BEECON_TOKEN +
                '&deviceId=' +
                uuidv4(),
            // user?.config?.beeconOrgId,
        };
        // Initialize Socket connection
        socketRef.current = io(SOCKET_SERVER_URL, options);

        // Handle connection open
        socketRef.current.on('connect', () => {
            console.log('Socket connected!');
        });

        // Handle data updates from the server
        socketRef.current.on('updateData', (updatedData: any) => {});
        socketRef.current.on('vehicletrackingEvent', function (data: any) {
            if (data) {
                alert('vehicletrackingEvent' + JSON.stringify(data));
            }
        });
        socketRef.current.on('vehicleTelematicEvent', async (data: any) => {
            // console.log('vehicleTelematicEvent', data);
            if (data) {
                alert('vehicleTelematicEvent' + JSON.stringify(data));
            }
        });

        // Handle connection close
        socketRef.current.on('disconnect', () => {
            console.log('Socket disconnected!');
        });
    };
    useEffect(() => {
        setFirstRenderDone(true);
        /*if (Notification.permission !== 'denied') {
            Notification.requestPermission();
        }*/
        //startLiveDataUpdate();
        dispatchGetAllEVVendors({});
        dispatchGetAllEVTeams({});
        dispatchGetAllEVProjects({});
        dispatchGetAllEVCaptains({});
        dispatchGetCities({});
        dispatchGetAllEVTelematics({});
        // Cleanup on component unmount
        return () => {
            //socketRef.current?.disconnect();
        };
    }, []);
    useEffect(() => {
        fetchEvVehiclesListData(preProcessPayload(evListingPayload));
    }, [evListingPayload]);
    useEffect(() => {
        const apiFilter =
            activeFilterCard === 'CRITICAL_FILTER'
                ? 'TAGGED_FILTER'
                : activeFilterCard;
        setEvListingPayload((prev: any) => {
            return {
                ...prev,
                pageNo: 1,
                filter: apiFilter,
            };
        });
        setPagination((prev: any) => {
            return {
                ...prev,
                pageNo: 0,
            };
        });
    }, [activeFilterCard]);
    const onFilterApplied = () => {
        const nextPayload = {
            ...evListingPayload,
            pageNo: 1,
            ...filteredValues,
            cityIds: filteredValues?.cityIds ?? [],
            cmIds: filteredValues?.cmIds ?? [],
            captainsIds: filteredValues?.captainsIds ?? [],
            projectIds: filteredValues?.projectIds ?? [],
            vendorIds: filteredValues?.vendorIds ?? [],
            telematicIds: filteredValues?.telematicIds ?? [],
        };
        setEvListingPayload(nextPayload);
        setPagination((prev: any) => ({ ...prev, pageNo: 0 }));
        fetchEvVehiclesListData(preProcessPayload(nextPayload));
    };

    const onFiltersCleared = () => {
        const meIdNum = isCmMode
            ? Number(user?.id ?? user?.userId ?? 0) || null
            : null;
        const reset: any = {
            cityIds: [],
            projectIds: [],
            vendorIds: [],
            telematicIds: [],
            captainsIds: [],
            cmIds: meIdNum ? [meIdNum] : [],
            manager: null,
            captainId: null,
            cmId: meIdNum,
            evStatus: 'TAGGED',
        };
        const nextFiltered = { ...filteredValues, ...reset };
        const nextPayload = {
            ...evListingPayload,
            ...reset,
            searchText: '',
            pageNo: 1,
        };
        setSearchText('');
        setFilteredValue(nextFiltered);
        setEvListingPayload(nextPayload);
        setPagination((prev: any) => ({ ...prev, pageNo: 0 }));
        fetchEvVehiclesListData(preProcessPayload(nextPayload));
    };

    const getActiveFilterChips = (): Array<{
        key: string;
        label: string;
        onRemove: () => void;
    }> => {
        const chips: Array<{ key: string; label: string; onRemove: () => void }> = [];
        if (searchText && searchText.trim().length > 0) {
            chips.push({
                key: 'search',
                label: `Search: "${searchText.trim()}"`,
                onRemove: () => setSearchText(''),
            });
        }
        const cityId = filteredValues?.cityIds?.[0];
        if (cityId) {
            const c = (cityList ?? []).find(
                (it: any) => String(it?.id) === String(cityId),
            );
            chips.push({
                key: 'city',
                label: `City: ${c?.name ?? cityId}`,
                onRemove: () =>
                    setFilteredValue({ ...filteredValues, cityIds: [] }),
            });
        }
        const projectId = filteredValues?.projectIds?.[0];
        if (projectId) {
            const p = (projectsList ?? []).find(
                (it: any) => String(it?.id) === String(projectId),
            );
            chips.push({
                key: 'vertical',
                label: `Vertical: ${p?.name ?? projectId}`,
                onRemove: () =>
                    setFilteredValue({ ...filteredValues, projectIds: [] }),
            });
        }
        if (!isCmMode && filteredValues?.cmId) {
            const m = (managerList ?? []).find(
                (it: any) => String(it?.id) === String(filteredValues.cmId),
            );
            chips.push({
                key: 'cm',
                label: `Cluster Manager: ${m?.name ?? filteredValues.cmId}`,
                onRemove: () =>
                    setFilteredValue({
                        ...filteredValues,
                        cmId: null,
                        cmIds: [],
                        manager: null,
                        captainId: null,
                        captainsIds: [],
                    }),
            });
        }
        if (filteredValues?.captainId) {
            const t = (captainList ?? []).find(
                (it: any) => String(it?.id) === String(filteredValues.captainId),
            );
            chips.push({
                key: 'tl',
                label: `TL: ${t?.name ?? filteredValues.captainId}`,
                onRemove: () =>
                    setFilteredValue({
                        ...filteredValues,
                        captainId: null,
                        captainsIds: [],
                    }),
            });
        }
        if (
            filteredValues?.evStatus &&
            filteredValues.evStatus !== 'TAGGED'
        ) {
            const s = (EVVEHICLE_STATUS_LIST_V2 ?? []).find(
                (it: any) => it?.status === filteredValues.evStatus,
            );
            chips.push({
                key: 'status',
                label: `Status: ${s?.label ?? filteredValues.evStatus}`,
                onRemove: () =>
                    setFilteredValue({ ...filteredValues, evStatus: 'TAGGED' }),
            });
        }
        return chips;
    };

    const permissionSignature = JSON.stringify(user?.config?.permission ?? {});
    useEffect(() => {
        // Wait for redux-persist to finish hydrating user.config on hard refresh —
        // otherwise getPermissions returns {read:false} and we bounce to /404.
        if (!user?.config?.permission) return;
        const next = getPermissions(permKey);
        setPermissions((prev: any) =>
            prev?.read === next.read &&
            prev?.update === next.update &&
            prev?.create === next.create &&
            prev?.delete === next.delete &&
            prev?.auth === next.auth &&
            prev?.allowStaffDelete === next.allowStaffDelete
                ? prev
                : next,
        );
        if (!next.read) {
            props.history.push(`/${getActiveInitRoute()}`);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [permissionSignature, permKey]);
    const updateFilterValues = (keysToRemove: Array<any>, obj: Object) => {
        const updatedObject = removeKeysFromObject(obj, keysToRemove);
        setFilteredValue(updatedObject);
    };
    const prepareFilterOptions = () => {
        let sVendor = vendorList?.filter(
            (item: any) => item?.id == filteredValues?.vendorIds?.[0],
        )?.[0];
        let sCaptain = captainList?.filter(
            (item: any) => item?.id == filteredValues?.captainId,
        )?.[0];
        let sManager = managerList?.filter(
            (item: any) => item?.manager == filteredValues?.manager,
        )?.[0];
        let sTeam = teamList?.filter(
            (item: any) => item?.id == filteredValues?.teamId,
        )?.[0];
        let sProject = projectsList?.filter(
            (item: any) => item?.id == filteredValues?.projectIds?.[0],
        )?.[0];
        let sTelamatic = telematicsList?.filter(
            (item: any) => item?.id == filteredValues?.telematicIds?.[0],
        )?.[0];
        return [
            {
                type: FILTER_INPUT_TYPE.DATE_RANGE_START_END,
                label: 'Date',
                startDate: 'Start Date',
                endDate: 'End Date',
                name: 'evDate',
                deleteDisable: true,
                value: {
                    startDate: filteredValues?.startDate,
                    endDate: filteredValues?.endDate,
                },
                onStartDateChange: (e: any) => {
                    console.log('onStartDateChange', e);
                    setFilteredValue({
                        ...filteredValues,
                        //evDate: e,
                        startDate: moment(e).format('YYYY-MM-DD'),
                    });
                },
                onEndDateChange: (e: any) => {
                    console.log('onEndDateChange', e);
                    setFilteredValue({
                        ...filteredValues,
                        endDate: moment(e).format('YYYY-MM-DD'),
                    });
                },
                render: () => {
                    return `Date: ${filteredValues.startDate} to ${filteredValues.endDate}`;
                },
            },
            {
                type: FILTER_INPUT_TYPE.SELECT,
                label: 'EV Status',
                name: 'evStatus',
                deleteDisable: true,
                value: !!filteredValues?.evStatus?.length
                    ? EVVEHICLE_STATUS_LIST_V2?.filter(
                          (item) => item?.status == filteredValues?.evStatus,
                      )?.[0]
                    : null,
                options: EVVEHICLE_STATUS_LIST_V2?.map((item: any) => ({
                    label: item.label,
                    value: item.id,
                    ...item,
                })),
                onChange: (e: any) => {
                    if (!!e?.target?.value) {
                        setFilteredValue({
                            ...filteredValues,
                            evStatus: e?.target?.value?.value
                                ? EVVEHICLE_STATUS_LIST_V2?.filter(
                                      (item) =>
                                          item?.id == Number(e.target.value.id),
                                  )?.[0]?.status
                                : '',
                        });
                    } else {
                        updateFilterValues(['evStatus'], filteredValues);
                    }
                },
            },
            {
                type: FILTER_INPUT_TYPE.MULTISELECT,
                label: 'Cities',
                name: 'cityIds',
                value: filteredValues?.cityIds ?? [],
                options: cityList?.map(
                    (item: any) =>
                        ({
                            label: item?.name,
                            value: item?.id,
                        }),
                ),
                onChange: (e: any) => {
                    if (!!e?.target?.value) {
                        setFilteredValue({
                            ...filteredValues,
                            cityIds: e?.target?.value,
                        });
                    } else {
                        updateFilterValues(['cityIds'], filteredValues);
                    }
                },
            },
            {
                type: FILTER_INPUT_TYPE.SELECT,
                label: 'Business Unit',
                name: 'manager',
                value: !!filteredValues?.manager
                    ? filteredValues?.manager
                    : null,
                render: () => {
                    return `Business: ${filteredValues?.manager?.manager}`;
                },
                options: managerList?.map((item: any) => ({
                    label: item?.manager,
                    value: item?.manager,
                    ...item,
                })),
                onChange: (e: any) => {
                    if (!!e?.target?.value) {
                        setFilteredValue({
                            ...filteredValues,
                            captainsIds: e?.target?.value?.values ?? [],
                            manager: e?.target?.value ?? null,
                        });
                    } else {
                        updateFilterValues(
                            ['captainsIds', 'manager'],
                            filteredValues,
                        );
                    }
                },
            } /*,
            {
                type: FILTER_INPUT_TYPE.SELECT,
                label: 'Team',
                name: 'teamId',
                value: filteredValues?.teamId ? sTeam : null,
                render: () => {
                    return `Team: ${sTeam?.name}`;
                },
                options: teamList?.map((item: any) => ({
                    label: item?.name,
                    value: item?.id,
                    ...item,
                })),
                onChange: (e: any) => {
                    setFilteredValue({
                        ...filteredValues,
                        teamId: Number(e?.target?.value?.id) ?? null,
                    });
                },
            },*/,
            {
                type: FILTER_INPUT_TYPE.SELECT,
                label: 'Project',
                name: 'projectIds',
                value: filteredValues?.projectIds ? sProject : null,
                render: () => {
                    return `Project: ${sProject?.name}`;
                },
                options: projectsList?.map((item: any) => ({
                    label: item?.name,
                    value: item?.id,
                    ...item,
                })),
                onChange: (e: any) => {
                    if (!!e?.target?.value) {
                        setFilteredValue({
                            ...filteredValues,
                            projectIds: !!Number(e?.target?.value?.id)
                                ? [Number(e?.target?.value?.id)]
                                : [],
                        });
                    } else {
                        updateFilterValues(['projectIds'], filteredValues);
                    }
                },
            },
            {
                type: FILTER_INPUT_TYPE.SELECT,
                label: 'Vendor',
                name: 'vendorIds',
                value: filteredValues?.vendorIds ? sVendor : null,
                render: () => {
                    return `Vendor: ${sVendor?.name}`;
                },
                options: vendorList?.map((item: any) => ({
                    label: item?.name,
                    value: item?.id,
                    ...item,
                })),
                onChange: (e: any) => {
                    if (!!e?.target?.value) {
                        setFilteredValue({
                            ...filteredValues,
                            vendorIds: !!Number(e?.target?.value?.id)
                                ? [Number(e?.target?.value?.id)]
                                : [],
                        });
                    } else {
                        updateFilterValues(['vendorIds'], filteredValues);
                    }
                },
            },
            {
                type: FILTER_INPUT_TYPE.SELECT,
                label: 'Telematrics',
                name: 'telematicIds',
                value: !!filteredValues?.telematicIds?.length
                    ? sTelamatic
                    : null,
                render: () => {
                    return `Telematric: ${sTelamatic?.name}`;
                },
                options: telematicsList?.map((item: any) => ({
                    label: item?.name,
                    value: item?.id,
                    ...item,
                })),
                onChange: (e: any) => {
                    if (!!e?.target?.value) {
                        setFilteredValue({
                            ...filteredValues,
                            telematicIds: !!Number(e?.target?.value?.id)
                                ? [Number(e?.target?.value?.id)]
                                : [],
                        });
                    } else {
                        updateFilterValues(['telematicIds'], filteredValues);
                    }
                },
            },
        ];
    };
    const handleChangePage = (event: any, newPage: any) => {
        console.log('SETPAGE ', newPage);
        setPagination((prev: any) => {
            return {
                ...prev,
                pageNo: newPage,
            };
        });
        setEvListingPayload((prev: any) => {
            return {
                ...prev,
                pageNo: newPage + 1,
            };
        });
    };

    const handleChangeRowsPerPage = (event: any) => {
        setPagination((prev: any) => {
            return {
                ...prev,
                pageNo: 0,
                pageSize: +event.target.value,
            };
        });
        setEvListingPayload((prev: any) => {
            return {
                ...prev,
                pageNo: 1,
                pageSize: event.target.value,
            };
        });
    };
    React.useEffect(() => {
        if (firstRenderDone) {
            setEvListingPayload((prev: any) => {
                return {
                    ...prev,
                    pageNo: 1,
                    searchText: searchText,
                };
            });
            setPagination((prev: any) => {
                return {
                    ...prev,
                    pageNo: 0,
                };
            });
        }
    }, [searchText]);
    React.useEffect(() => {
        if (firstRenderDone) {
            onFilterApplied();
        }
    }, [filteredValues?.evStatus]);
    React.useEffect(() => {
        if (!firstRenderDone) return;
        const apiKey = sortConfig.key ? SORT_KEY_TO_API[sortConfig.key] ?? null : null;
        setEvListingPayload((prev: any) => ({
            ...prev,
            pageNo: 1,
            sortBy: apiKey,
            sortDir: apiKey ? sortConfig.direction : null,
        }));
        setPagination((prev: any) => ({ ...prev, pageNo: 0 }));
    }, [sortConfig.key, sortConfig.direction]);

    const sameIdList = (a: any[] = [], b: any[] = []) => {
        const aa = (a ?? []).map(String).sort().join(',');
        const bb = (b ?? []).map(String).sort().join(',');
        return aa === bb;
    };
    const filtersDirty =
        !sameIdList(
            filteredValues?.cityIds ?? [],
            evListingPayload?.cityIds ?? [],
        ) ||
        !sameIdList(
            filteredValues?.projectIds ?? [],
            evListingPayload?.projectIds ?? [],
        ) ||
        !sameIdList(
            filteredValues?.cmIds ?? [],
            evListingPayload?.cmIds ?? [],
        ) ||
        !sameIdList(
            filteredValues?.captainsIds ?? [],
            evListingPayload?.captainsIds ?? [],
        );
    console.log('fdddddddddd filteredValues', filteredValues, managerList);
    return (
        <Spinner loading={loading}>
            <Paper
                style={{ padding: '1rem', paddingBottom: 0 }}
                className={classes.container}
                elevation={0}
            >
                <Box
                    mb={2}
                    display={'flex'}
                    flexDirection={'row'}
                    alignItems={'center'}
                    justifyContent={'space-between'}
                    style={{ gap: 12 }}
                >
                    <Box>
                        <Typography
                            component={'h1'}
                            style={{
                                fontSize: 22,
                                fontWeight: 700,
                                color: '#14112D',
                                margin: 0,
                            }}
                        >
                            EV Control Tower — Active EVs
                        </Typography>
                        <Typography
                            component={'p'}
                            style={{
                                fontSize: 13,
                                color: '#515f6d',
                                marginTop: 2,
                            }}
                        >
                            Prioritized view · Auto-refresh every 15 min · Last refresh: 2 min ago
                        </Typography>
                    </Box>
                    <Button
                        variant="outlined"
                        onClick={() =>
                            props?.history?.push('/ev-sp/report')
                        }
                        style={{
                            borderRadius: 10,
                            fontWeight: 600,
                            fontSize: 13,
                            textTransform: 'none',
                            padding: '7px 16px',
                            height: 40,
                            borderColor: '#EBEDF8',
                            color: '#9AA3B2',
                            whiteSpace: 'nowrap',
                            background: '#FFFFFF',
                        }}
                    >
                        Other Reports
                    </Button>
                </Box>
                <Box
                    display={'flex'}
                    flexDirection={'row'}
                    alignItems={'center'}
                    justifyContent={'space-between'}
                    mb={2}
                    style={{ gap: 12, flexWrap: 'nowrap' }}
                >
                    <Box
                        display={'flex'}
                        flexDirection={'row'}
                        alignItems={'center'}
                        style={{
                            flex: '1 1 200px',
                            minWidth: 160,
                            background: '#FFFFFF',
                            border: '1px solid #EBEDF8',
                            borderRadius: 10,
                            padding: '8px 12px',
                            height: 40,
                        }}
                    >
                        <span
                            style={{
                                color: '#9AA3B2',
                                marginRight: 8,
                                fontSize: 14,
                            }}
                        >
                            🔍
                        </span>
                        <input
                            type="text"
                            value={searchText}
                            onChange={(e: any) => setSearchText(e.target.value)}
                            placeholder="Search by rider name, mobile, EV number, chassis..."
                            style={{
                                border: 'none',
                                outline: 'none',
                                flex: 1,
                                fontSize: 13,
                                color: '#14112D',
                                background: 'transparent',
                            }}
                        />
                    </Box>

                    <Box
                        display={'flex'}
                        flexDirection={'row'}
                        alignItems={'center'}
                        style={{ gap: 10, flexWrap: 'nowrap' }}
                    >
                        <SearchableSelect
                            label="City"
                            value={String(filteredValues?.cityIds?.[0] ?? '')}
                            options={(cityList ?? []).map((c: any) => ({
                                label: c?.name,
                                value: String(c?.id),
                            }))}
                            onChange={(v: string) =>
                                setFilteredValue({
                                    ...filteredValues,
                                    cityIds: v ? [v] : [],
                                })
                            }
                        />
                        <SearchableSelect
                            label="Vertical"
                            value={String(filteredValues?.projectIds?.[0] ?? '')}
                            options={(projectsList ?? []).map((p: any) => ({
                                label: p?.name,
                                value: String(p?.id),
                            }))}
                            onChange={(v: string) =>
                                setFilteredValue({
                                    ...filteredValues,
                                    projectIds: v ? [Number(v)] : [],
                                })
                            }
                        />
                        {!isCmMode && (
                            <SearchableSelect
                                label="Cluster Manager"
                                value={String(filteredValues?.cmId ?? '')}
                                options={(managerList ?? []).map((m: any) => ({
                                    label: `${m?.name} (${m?.values?.length ?? 0} TL${
                                        (m?.values?.length ?? 0) === 1 ? '' : 's'
                                    })`,
                                    value: String(m?.id),
                                }))}
                                onChange={(v: string) => {
                                    const m = (managerList ?? []).find(
                                        (mg: any) => String(mg.id) === v,
                                    );
                                    setFilteredValue({
                                        ...filteredValues,
                                        cmId: v ? Number(v) : null,
                                        cmIds: v ? [Number(v)] : [],
                                        // Reset TL selection when CM changes; pre-narrow captains list happens below.
                                        captainId: null,
                                        captainsIds: m?.values?.map((c: any) => c?.id) ?? [],
                                        manager: m
                                            ? { manager: m.name, values: m.values }
                                            : null,
                                    });
                                }}
                            />
                        )}
                        <SearchableSelect
                            label="TL"
                            value={String(filteredValues?.captainId ?? '')}
                            options={(
                                filteredValues?.cmId
                                    ? (captainList ?? []).filter(
                                          (c: any) =>
                                              String(c?.cmId) ===
                                              String(filteredValues.cmId),
                                      )
                                    : captainList ?? []
                            ).map((c: any) => ({
                                label: c?.name,
                                value: String(c?.id),
                            }))}
                            onChange={(v: string) =>
                                setFilteredValue({
                                    ...filteredValues,
                                    captainId: v ? Number(v) : null,
                                    captainsIds: v ? [Number(v)] : [],
                                })
                            }
                        />
                        <SearchableSelect
                            label="Status"
                            value={String(filteredValues?.evStatus ?? '')}
                            options={(EVVEHICLE_STATUS_LIST_V2 ?? [])
                                .filter((s: any) => s?.status !== 'All')
                                .map((s: any) => ({
                                    label: s?.label,
                                    value: s?.status,
                                }))}
                            onChange={(v: string) =>
                                setFilteredValue({
                                    ...filteredValues,
                                    evStatus: v,
                                })
                            }
                        />
                        <Button
                            variant="contained"
                            onClick={onFilterApplied}
                            style={{
                                borderRadius: 10,
                                fontWeight: 700,
                                fontSize: 13,
                                textTransform: 'none',
                                padding: '7px 18px',
                                height: 40,
                                background: '#0F1F8D',
                                color: '#fff',
                                boxShadow: '0 4px 12px rgba(15,31,141,0.35)',
                                marginLeft: 8,
                            }}
                        >
                            Apply
                        </Button>
                        <Button
                            variant="outlined"
                            onClick={onFiltersCleared}
                            style={{
                                borderRadius: 10,
                                fontWeight: 600,
                                fontSize: 13,
                                textTransform: 'none',
                                padding: '7px 14px',
                                height: 40,
                                borderColor: '#D7DBE8',
                                color: '#3B3F52',
                                marginLeft: 6,
                            }}
                        >
                            Clear
                        </Button>
                    </Box>

                </Box>
                {(() => {
                    const chips = getActiveFilterChips();
                    if (chips.length === 0) return null;
                    return (
                        <Box
                            display={'flex'}
                            flexDirection={'row'}
                            flexWrap={'wrap'}
                            alignItems={'center'}
                            mb={2}
                            style={{ gap: 8 }}
                        >
                            <Typography
                                style={{
                                    fontSize: 12,
                                    color: '#6B7280',
                                    fontWeight: 600,
                                    marginRight: 4,
                                }}
                            >
                                Active filters:
                            </Typography>
                            {chips.map((chip) => (
                                <Box
                                    key={chip.key}
                                    style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        gap: 6,
                                        padding: '4px 10px',
                                        borderRadius: 999,
                                        background: '#EEF2FF',
                                        color: '#0F1F8D',
                                        fontSize: 12,
                                        fontWeight: 600,
                                        border: '1px solid #DDE3FB',
                                    }}
                                >
                                    <span>{chip.label}</span>
                                    <span
                                        onClick={chip.onRemove}
                                        style={{
                                            cursor: 'pointer',
                                            fontSize: 14,
                                            lineHeight: 1,
                                            color: '#0F1F8D',
                                            opacity: 0.7,
                                        }}
                                        title="Remove"
                                    >
                                        ×
                                    </span>
                                </Box>
                            ))}
                            <Box
                                onClick={onFiltersCleared}
                                style={{
                                    cursor: 'pointer',
                                    fontSize: 12,
                                    fontWeight: 600,
                                    color: '#B91C1C',
                                    marginLeft: 4,
                                    textDecoration: 'underline',
                                }}
                            >
                                Clear all
                            </Box>
                        </Box>
                    );
                })()}
                <Box flexGrow={1} mb={3}>
                    <Grid container spacing={2}>
                        {EV_FILTER_CARDS?.map((card: any, index: number) => (
                            <React.Fragment key={card?.type ?? `card-${index}`}>
                                {getCardFilterView(card, EV_FILTER_CARDS?.length)}
                            </React.Fragment>
                        ))}
                    </Grid>
                </Box>
                <Box
                    display={'flex'}
                    flexDirection={'row'}
                    flexWrap={'wrap'}
                    alignItems={'center'}
                    style={{ gap: 8 }}
                    mb={3}
                >
                    {(() => {
                        // Server returns bucketCounts across the FULL filtered set (not the current page).
                        const serverCounts: Record<string, number> =
                            evListData?.bucketCounts ?? {};
                        const apiToTabKey: Record<string, string> = {
                            Critical: 'CRITICAL',
                            High: 'HIGH',
                            Medium: 'MEDIUM',
                            Watch: 'WATCH',
                            Healthy: 'HEALTHY',
                            NOT_CALCULATED: 'NOT_CALCULATED',
                        };
                        const tabKeyCounts: Record<string, number> = {};
                        Object.keys(serverCounts).forEach((k) => {
                            const tabKey = apiToTabKey[k];
                            if (tabKey) tabKeyCounts[tabKey] = serverCounts[k] ?? 0;
                        });
                        const totalAll = Number(evListData?.totalCount ?? 0);
                        return EV_SEVERITY_TABS.map((tab: any) => {
                            const active = activeSeverityTab === tab.key;
                            const count =
                                tab.key === 'ALL'
                                    ? totalAll
                                    : tabKeyCounts[tab.key] ?? 0;
                            tab = { ...tab, count };
                        return (
                            <Box
                                key={tab.key}
                                onClick={() => setActiveSeverityTab(tab.key)}
                                style={{
                                    cursor: 'pointer',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: 8,
                                    padding: '6px 14px',
                                    borderRadius: 999,
                                    border: `1px solid ${active ? '#43419e' : '#EBEDF8'}`,
                                    background: active ? '#d1d8ff' : '#FFFFFF',
                                    color: active ? '#14112D' : '#515f6d',
                                    fontSize: 13,
                                    fontWeight: 600,
                                }}
                            >
                                {tab.dot && (
                                    <span
                                        style={{
                                            display: 'inline-block',
                                            width: 8,
                                            height: 8,
                                            borderRadius: '50%',
                                            background: tab.dot,
                                        }}
                                    />
                                )}
                                <span>{tab.label}</span>
                                <span
                                    style={{
                                        background: active ? '#FFFFFF' : '#e8e8ee',
                                        color: active ? '#14112D' : '#515f6d',
                                        borderRadius: 999,
                                        padding: '0 6px',
                                        fontSize: 11,
                                        fontWeight: 700,
                                        minWidth: 18,
                                        textAlign: 'center',
                                    }}
                                >
                                    {tab.count}
                                </span>
                            </Box>
                        );
                        });
                    })()}
                </Box>
                {evListData?.evLineItemList?.length ? (
                    <>
                        <TableContainer
                            component={Box}
                            className={classes.tableContainer}
                        >
                            <Table stickyHeader aria-label="Orders table">
                                <TableHead>
                                    <TableRow>
                                        {tableConfig?.columns?.map(
                                            (column: any, index: any) => {
                                                const sortable =
                                                    SORTABLE_COLUMN_KEYS.has(
                                                        column?.mappingKey,
                                                    );
                                                const isActive =
                                                    sortConfig.key ===
                                                    column?.mappingKey;
                                                const arrow = !sortable
                                                    ? ''
                                                    : !isActive
                                                    ? ' ⇅'
                                                    : sortConfig.direction === 'asc'
                                                    ? ' ↑'
                                                    : ' ↓';
                                                return (
                                                    <StyledTableHeadCell
                                                        key={`column${index}`}
                                                        onClick={
                                                            sortable
                                                                ? () =>
                                                                      handleSortClick(
                                                                          column?.mappingKey,
                                                                      )
                                                                : undefined
                                                        }
                                                        style={{
                                                            cursor: sortable
                                                                ? 'pointer'
                                                                : 'default',
                                                            userSelect: 'none',
                                                            color: isActive
                                                                ? '#14112D'
                                                                : undefined,
                                                        }}
                                                    >
                                                        {column?.name}
                                                        <span
                                                            style={{
                                                                opacity: isActive
                                                                    ? 1
                                                                    : 0.45,
                                                                fontWeight: 700,
                                                            }}
                                                        >
                                                            {arrow}
                                                        </span>
                                                    </StyledTableHeadCell>
                                                );
                                            },
                                        )}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {evListData?.evLineItemList
                                        ?.filter((row: any) => {
                                            if (
                                                activeFilterCard ===
                                                'CRITICAL_FILTER'
                                            ) {
                                                return getEvBucket(row) === 'CRITICAL';
                                            }
                                            // BLOCKED_FILTER is now applied server-side
                                            // via filter: "BLOCKED_FILTER" — no client filter needed.
                                            return true;
                                        })
                                        ?.map(
                                        (row: any, rowIndex: number) => (
                                            <StyledTableRow
                                                key={row?.evId ?? row?.id ?? `row-${rowIndex}`}
                                                onClick={(e: any) => {
                                                    handleRowClick(
                                                        e,
                                                        row,
                                                        rowIndex,
                                                    );
                                                }}
                                            >
                                                {tableConfig?.columns?.map(
                                                    (
                                                        column: any,
                                                        index: any,
                                                    ) => {
                                                        return (
                                                            <StyledTableCell
                                                                key={`row${index}`}
                                                            >
                                                                {getColumnComponentValue(
                                                                    row,
                                                                    column,
                                                                    null,
                                                                    rowIndex,
                                                                )}
                                                            </StyledTableCell>
                                                        );
                                                    },
                                                )}
                                            </StyledTableRow>
                                        ),
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            rowsPerPageOptions={
                                evListData?.totalCount > 25 ? [25, 50, 75] : []
                            }
                            component="div"
                            count={evListData?.totalCount}
                            rowsPerPage={pagination?.pageSize}
                            page={pagination?.pageNo}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                        />
                    </>
                ) : (
                    <Box
                        display={'flex'}
                        flexDirection={'column'}
                        alignItems={'center'}
                        justifyContent={'center'}
                    >
                        <Typography
                            component={'p'}
                            style={{
                                color: '#ED0000',
                                fontWeight: 700,
                            }}
                        >
                            No data found. Please retry filters and try again.
                        </Typography>
                    </Box>
                )}
            </Paper>
            <SendLocationModal
                open={!!sendLocationRow}
                row={sendLocationRow}
                onClose={() => setSendLocationRow(null)}
            />
            <BlockUnblockModal
                open={!!blockModal}
                row={blockModal?.row}
                mode={blockModal?.mode ?? 'block'}
                loading={blockLoading}
                onClose={() => setBlockModal(null)}
                onConfirm={(payload) => {
                    const row = payload?.row;
                    if (!row?.evId) {
                        showMessage('Missing EV id', 'error');
                        return;
                    }
                    const action = payload.mode === 'block' ? 'BLOCK' : 'UNBLOCK';
                    const remarks = [
                        (payload.reasons || []).join(','),
                        payload.note ? `note: ${payload.note}` : '',
                    ]
                        .filter(Boolean)
                        .join(' | ');
                    setBlockLoading(true);
                    const partner = blockModal?.partner;
                    const dispatchBlock =
                        partner === 'iot'
                            ? dispatchEvBlockIot
                            : partner === 'energy'
                            ? dispatchEvBlockEnergy
                            : dispatchEvBlock;
                    dispatchBlock(
                        { evId: row.evId, evNumber: row.evVehicleNumber, action, remarks },
                        (resp: any) => {
                            setBlockLoading(false);
                            const ok = resp?.status?.code == 200;
                            const { message, variant } = formatEvBlockResult(resp);
                            showMessage(message, variant);
                            if (ok) {
                                setBlockModal(null);
                                fetchEvVehiclesListData(preProcessPayload(evListingPayload));
                            }
                        },
                        () => {
                            setBlockLoading(false);
                            showMessage('Block request failed', 'error');
                        },
                    );
                }}
            />
            {!!confirmModalOpen && !!confirmData && (
                <ConfirmModal
                    open={confirmModalOpen}
                    data={confirmData}
                    onClose={() => {
                        handleConfirmNo(confirmData);
                    }}
                    confirmationText={confirmData?.confirmText}
                    onAction={() => {
                        handleConfirmYes(confirmData);
                    }}
                />
            )}
        </Spinner>
    );
};

export default EVPage;
